"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlCachedPaymentValidation = void 0;
const PaymentTerminalControlPaymentWithPayloadValidation_1 = require("./PaymentTerminalControlPaymentWithPayloadValidation");
class PaymentTerminalControlCachedPaymentValidation {
    static isValid(entity) {
        // If entity.cached_payment exists, validate that it has the correct type.
        if (entity.cached_payment != undefined) {
            if (!PaymentTerminalControlPaymentWithPayloadValidation_1.PaymentTerminalControlPaymentWithPayloadValidation.isValid(entity.cached_payment))
                return false;
        }
        return true;
    }
}
exports.PaymentTerminalControlCachedPaymentValidation = PaymentTerminalControlCachedPaymentValidation;
